import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styles from './styles.module.css';
export function usePrefix({ prefix, disabled }) {
    return useMemo(() => ({
        id: 'prefix',
        active: false,
        show: Boolean(prefix),
        render: props => (_jsx("div", Object.assign({}, props, { "data-test-id": 'field-prefix', className: styles.prefix, "data-disabled": disabled || undefined, children: prefix }))),
    }), [disabled, prefix]);
}
